import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './get-the-app-banner.component.scss';
var GetTheAppBanner = /** @class */ (function (_super) {
    tslib_1.__extends(GetTheAppBanner, _super);
    function GetTheAppBanner(element) {
        return _super.call(this, element) || this;
    }
    GetTheAppBanner.prototype.init = function () {
    };
    GetTheAppBanner.prototype.bindEvents = function () {
    };
    return GetTheAppBanner;
}(Base));
export { GetTheAppBanner };



//////////////////
// WEBPACK FOOTER
// ./components/get-the-app-banner/get-the-app-banner.component.ts
// module id = 341
// module chunks = 0